
import React from 'react';
import { useLang } from '@/contexts/LangContext';

const Footer = () => {
  const { t } = useLang();
  
  return (
    <div className="mt-auto pt-16 pb-8 text-center text-xs text-gray-500 z-10 border-t border-gray-900">
      <div className="flex flex-col md:flex-row justify-between items-center max-w-5xl mx-auto px-4 space-y-2 md:space-y-0">
        <p>&copy; {new Date().getFullYear()} METRADE. {t.footer.copyright}</p>
      </div>
    </div>
  );
};

export default Footer;
